var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider" }, [
    _c("div", { staticClass: "slider__body" }, [
      _c("div", {
        staticClass: "slider__arrow slider__arrow--prev",
        class: { "is-hidden": _vm.currPage == 1 },
        on: {
          click: function ($event) {
            _vm.currPage--
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "slider__track" }, [
        _c(
          "div",
          {
            staticClass: "slider__mat",
            style: {
              transform: "translateX(" + _vm.trackPos + ")",
              justifyContent: _vm.numPages == 1 ? "center" : "",
            },
          },
          [_vm._t("default")],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "slider__arrow slider__arrow--next",
        class: { "is-hidden": _vm.currPage == _vm.numPages },
        on: {
          click: function ($event) {
            _vm.currPage++
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }